import { NgModule, Injectable } from '@angular/core';
import { Routes, RouterModule, CanLoad, Router, Route, UrlSegment } from '@angular/router';

import { Observable } from 'rxjs';

import { MainLayoutComponent } from '@teem/layouts/main-layout.component';

import { PLAN_TYPES, SUBSCRIPTION_STATUS, USER_TYPE } from '@teem/core/constants/subscription';

import { STORE_TYPE } from '@teem/core/constants/defaults';
import { AuthComponent } from './features/auth/auth.component';
import { CustomerComponent } from '@teem/customer/customer.component';

let subscription:any = (window as any).userInfo ? (window as any).userInfo.subscription : null;
let defaultRoute: string = 'subscription-plan';

if(!subscription || SUBSCRIPTION_STATUS.active != subscription.subscription_status) {
  defaultRoute = 'subscription-plan';
} 

if(!subscription || SUBSCRIPTION_STATUS.free != subscription.subscription_plan) {
  defaultRoute = 'dashboard';
} 

let user: any = (window as any).userInfo ? (window as any).userInfo : null;
if (user.user_type == USER_TYPE.user) {
  defaultRoute = 'invoices';//'subscription-plan';

  const subscriptionPlan = user?.subscription?.subscription_plan; // this.user?.subscription?.subscription_plan;
  if (
    subscriptionPlan == "online-ordering-basic" || 
    subscriptionPlan == "online-ordering-pro" || 
    subscriptionPlan == "online-ordering-enterprise" ||
    subscriptionPlan == "online-store-basic" ||
    subscriptionPlan == "online-store-pro" ||
    subscriptionPlan == "online-store-enterprise"
  ) {
    defaultRoute = 'orders';
  }
}

@Injectable()
export class CanLoadBusinessSection implements CanLoad {

  constructor(private router: Router) {}

  canLoad(): Observable<boolean>|Promise<boolean>|boolean {
    let subscription:any = (window as any).userInfo ? (window as any).userInfo.subscription : null;

    // if(subscription && subscription.subscription_status == SUBSCRIPTION_STATUS.active && (subscription.subscription_plan == PLAN_TYPES.business))
    //   return true;
    // else {
    //   this.router.navigateByUrl(defaultRoute);
    //   return false;
    // }
    if(
      subscription && subscription.subscription_status == SUBSCRIPTION_STATUS.active && 
      ((subscription.subscription_plan == PLAN_TYPES.business) ||
      (subscription.subscription_plan == PLAN_TYPES.invoice_basic) ||
      (subscription.subscription_plan == PLAN_TYPES.invoice_pro) ||
      (subscription.subscription_plan == PLAN_TYPES.invoice_enterprise) ||
      (subscription.subscription_plan == PLAN_TYPES.online_store_basic) ||
      (subscription.subscription_plan == PLAN_TYPES.online_store_pro) ||
      (subscription.subscription_plan == PLAN_TYPES.online_store_enterprise) ||
      (subscription.subscription_plan == PLAN_TYPES.online_ordering_basic) ||
      (subscription.subscription_plan == PLAN_TYPES.online_ordering_pro) ||
      (subscription.subscription_plan == PLAN_TYPES.online_ordering_enterprise) ||
      (subscription.subscription_plan == PLAN_TYPES.complete_solution))
    )
      return true;
    else {
      this.router.navigateByUrl(defaultRoute);
      return false;
    }
  }
}

@Injectable()
export class CanLoadProSection implements CanLoad {

  constructor(private router: Router) { }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    let subscription: any = (window as any).userInfo ? (window as any).userInfo.subscription : null;

    if(subscription && subscription.subscription_status == SUBSCRIPTION_STATUS.active && 
      (
        subscription.subscription_plan == PLAN_TYPES.pro || 
        subscription.subscription_plan == PLAN_TYPES.professional || 
        subscription.subscription_plan == PLAN_TYPES.business ||
        (subscription.subscription_plan == PLAN_TYPES.invoice_basic) ||
        (subscription.subscription_plan == PLAN_TYPES.invoice_pro) ||
        (subscription.subscription_plan == PLAN_TYPES.invoice_enterprise) ||
        (subscription.subscription_plan == PLAN_TYPES.online_store_basic) ||
        (subscription.subscription_plan == PLAN_TYPES.online_store_pro) ||
        (subscription.subscription_plan == PLAN_TYPES.online_store_enterprise) ||
        (subscription.subscription_plan == PLAN_TYPES.online_ordering_basic) ||
        (subscription.subscription_plan == PLAN_TYPES.online_ordering_pro) ||
        (subscription.subscription_plan == PLAN_TYPES.online_ordering_enterprise) ||
        (subscription.subscription_plan == PLAN_TYPES.complete_solution)
      )
    )
      return true;
    else {
      this.router.navigateByUrl(defaultRoute);
      return false;
    }
  }
}

@Injectable()
export class CanLoadBasicSection implements CanLoad {

  constructor(private router: Router) { }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    let subscription: any = (window as any).userInfo ? (window as any).userInfo.subscription : null;

    if (subscription && subscription.subscription_status == SUBSCRIPTION_STATUS.active)
      return true;
    else {
      this.router.navigateByUrl(defaultRoute);
      return false;
    }
  }
}


@Injectable()
export class CanLoadProductSection implements CanLoad {

  constructor(private router: Router) { }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    let user: any = (window as any).userInfo ? (window as any).userInfo : null;
    if (user.store_type == STORE_TYPE.PRODUCT)
      return true;
    else {
      this.router.navigateByUrl(defaultRoute);
      return false;
    }
  }
}

@Injectable()
export class CanLoadServiceSection implements CanLoad {

  constructor(private router: Router) { }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    let user: any = (window as any).userInfo ? (window as any).userInfo : null;
    if (user.store_type == STORE_TYPE.SERVICE)
      return true;
    else {
      this.router.navigateByUrl(defaultRoute);
      return false;
    }
  }
}

@Injectable()
export class CanLoadSuperAdminSection implements CanLoad {

  constructor(private router: Router) { }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    let user: any = (window as any).userInfo ? (window as any).userInfo : null;
    if (user.user_type == USER_TYPE.super_admin)
      return true;
    else {
      this.router.navigateByUrl(defaultRoute);
      return false;
    }
  }
}

@Injectable()
export class CanLoadAdminSection implements CanLoad {

  constructor(private router: Router) { }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    let user: any = (window as any).userInfo ? (window as any).userInfo : null;
    if (user.user_type == USER_TYPE.admin || user.user_type == USER_TYPE.super_admin)
      return true;
    else {
      this.router.navigateByUrl(defaultRoute);
      return false;
    }
  }
}

@Injectable()
export class CanLoadUserSection implements CanLoad {

  constructor(private router: Router) { }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    let user: any = (window as any).userInfo ? (window as any).userInfo : null;
    if (user.user_type == USER_TYPE.user || user.user_type == USER_TYPE.admin || user.user_type == USER_TYPE.super_admin)
      return true;
    else {
      this.router.navigateByUrl(defaultRoute);
      return false;
    }
  }
}

@Injectable()
export class CanLoadAllowedModule implements CanLoad {

  constructor(private router: Router) { }
  
  private subscriptionAccess = {
    "basic": ['dashboard', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'users'],
    "pro": ['dashboard', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'branches'],
    "individual": ['dashboard', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'users'],
    "professional": ['dashboard', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'branches'],
    "business": ['dashboard', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports', 'branches'],

    "invoice-basic": ['dashboard', 'invoices','payments','create-invoice', 'expenses', 'quotations','clients','subscription-plan','setting','billing', 'services', 'products', 'users'],
    "invoice-pro": ['dashboard', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'services', 'products', 'users'],
    "invoice-enterprise": ['dashboard', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'services', 'products', 'users'],
    "online-store-basic": ['dashboard', 'clients', 'subscription-plan', 'setting', 'expenses', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports', 'branches'], // 'invoices', 'payments', 'create-invoice', 'expenses', 'proposals',
    "online-store-pro": ['dashboard', 'clients', 'subscription-plan', 'setting', 'expenses', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports', 'branches'], // 'invoices', 'payments', 'create-invoice', 'expenses', 'proposals',
    "online-store-enterprise": ['dashboard', 'clients', 'subscription-plan', 'setting', 'expenses', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports', 'branches'], // 'invoices', 'payments', 'create-invoice', 'expenses', 'proposals',
    "online-ordering-basic": ['dashboard', 'clients', 'subscription-plan', 'setting', 'expenses', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports', 'branches'], // 'invoices', 'payments', 'create-invoice', 'expenses', 'proposals',
    "online-ordering-pro": ['dashboard', 'clients', 'subscription-plan', 'setting', 'expenses', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports', 'branches'], // 'invoices', 'payments', 'create-invoice', 'expenses', 'proposals',
    "online-ordering-enterprise": ['dashboard', 'clients', 'subscription-plan', 'setting', 'expenses', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports', 'branches'], // 'invoices', 'payments', 'create-invoice', 'expenses', 'proposals',
    "complete-solution": ['dashboard', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports', 'branches'],
  };

  hasAccessToModule(moduleName: string, userSubscription: string): boolean {
      const allowedModules = this.subscriptionAccess[userSubscription] || [];
      return allowedModules.includes(moduleName);
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {

    let subscription:any = (window as any).userInfo ? (window as any).userInfo.subscription : null;
        
    const moduleName = route.path || ''; // Get the module name from the route
    const hasAccess = this.hasAccessToModule(moduleName, subscription?.subscription_plan);

    if (!hasAccess) {
      this.router.navigateByUrl(defaultRoute);
    }

    return hasAccess;
  }
}

@Injectable()
export class CanLoadAuthSection implements CanLoad {

  constructor(private router: Router) { }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    let user: any = (window as any).userInfo ? (window as any).userInfo : null;
    if (user.user_type) {
      this.router.navigateByUrl(defaultRoute);
      return false;
    } else {
      return true;
    }
  }
}


const routes: Routes = [
  {
    path: '',
    redirectTo: defaultRoute,
    pathMatch: 'full',
  },
  { 
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'signup',
        canLoad: [CanLoadAuthSection],
        loadChildren: () => import('@teem/features/auth/signup/signup.module').then(m => m.SignupModule)
      },
      {
        path: 'login',
        canLoad: [CanLoadAuthSection],
        loadChildren: () => import('@teem/features/auth/signin/signin.module').then(m => m.SigninModule)
      },
      {
        path: 'forgot-password',
        canLoad: [CanLoadAuthSection],
        loadChildren: () => import('@teem/features/auth/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
      },
    ]
  },
  { 
    path: '',
    component: CustomerComponent,
    children: [
      {
        path: 'profile',
        canLoad: [CanLoadAuthSection],
        loadChildren: () => import('@teem/customer/profile/profile.module').then(m => m.ProfileModule)
      }
    ]
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'dashboard',
        canLoad: [CanLoadAllowedModule, CanLoadAdminSection],
        loadChildren: () => import('@teem/features/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'invoices',
        canLoad: [CanLoadAllowedModule, CanLoadUserSection],
        loadChildren: () => import('@teem/features/invoices/invoices.module').then(m => m.InvoicesModule)
      },
      {
        path: 'payments',
        canLoad: [CanLoadAllowedModule, CanLoadAdminSection],
        loadChildren: () => import('@teem/features/payments/payments.module').then(m => m.PaymentsModule)
      },
      {
        path: 'create-invoice',
        canLoad: [CanLoadAllowedModule, CanLoadUserSection],
        loadChildren: () => import('@teem/features/invoices/invoices.module').then(m => m.InvoicesModule)
      },
      {
        path: 'expenses',
        canLoad: [CanLoadAllowedModule, CanLoadAdminSection],
        loadChildren: () => import('@teem/features/expenses/expenses.module').then(m => m.ExpensesModule)
      },
      {
        path: 'quotations',
        canLoad: [CanLoadAllowedModule, CanLoadAdminSection],
        loadChildren: () => import('@teem/features/quotes/quotes.module').then(m => m.QuotesModule)
      },
      {
        path: 'proposals',
        canLoad: [CanLoadAllowedModule, CanLoadAdminSection],
        loadChildren: () => import('@teem/features/proposals/proposals.module').then(m => m.ProposalsModule)
      },
      {
        path: 'clients',
        canLoad: [CanLoadAllowedModule, CanLoadAdminSection],
        loadChildren: () => import('@teem/features/clients/clients.module').then(m => m.ClientsModule)
      },
      {
        path: 'subscription-plan',
        loadChildren: () => import('@teem/features/subscription-plan/subscription-plan.module').then(m => m.SubscriptionPlanModule)
      },
      {
        path: 'setting',
        loadChildren: () => import('@teem/features/setting/setting.module').then(m => m.SettingModule)
      },
      {
        path: 'billing',
        canLoad: [CanLoadSuperAdminSection],
        loadChildren: () => import('@teem/features/billing/billing.module').then(m => m.BillingModule)
      },
      {
        path: 'taxes',
        canLoad: [CanLoadAllowedModule, CanLoadAdminSection],
        loadChildren: () => import('@teem/features/taxes/taxes.module').then(m => m.TaxesModule)
      },
      {
        path: 'store',
        canLoad: [CanLoadAllowedModule, CanLoadSuperAdminSection],
        loadChildren: () => import('@teem/web-market/store-information/store-information.module').then(m => m.StoreInformationModule)
      },
      {
        path: 'services',
        canLoad: [CanLoadAllowedModule, CanLoadServiceSection, CanLoadUserSection], // CanLoadAdminSection
        loadChildren: () => import('@teem/web-market/store-services/store-services.module').then(m => m.StoreServicesModule)
      },
      {
        path: 'products',
        canLoad: [CanLoadAllowedModule, CanLoadProductSection, CanLoadUserSection], // CanLoadAdminSection
        loadChildren: () => import('@teem/web-market/products/products.module').then(m => m.ProductsModule)
      },
      {
        path: 'orders',
        canLoad: [CanLoadAllowedModule, CanLoadUserSection], // CanLoadAdminSection
        loadChildren: () => import('@teem/web-market/orders/orders.module').then(m => m.OrdersModule)
      },
      {
        path: 'users',
        canLoad: [CanLoadAllowedModule, CanLoadSuperAdminSection],
        loadChildren: () => import('@teem/features/users/users.module').then(m => m.UsersModule)
      }
      ,
      {
        path: 'wallets',
        canLoad: [CanLoadAdminSection],
        loadChildren: () => import('@teem/features/wallets/wallets.module').then(m => m.WalletsModule)
      },
      {
        path: 'storefront-analytics',
        canLoad: [CanLoadAdminSection],
        loadChildren: () => import('@teem/features/storefront-analytics/storefront-analytics.module').then(m => m.StorefrontAnalyticsModule)
      },
      {
        path: 'influencer-analytics',
        loadChildren: () => import('@teem/features/influence-analytics/influencer-analytics.module').then(m => m.InfluencerAnalyticsModule)
      },
      {
        path: 'profit-loss-statement',
        canLoad: [CanLoadAdminSection],
        loadChildren: () => import('@teem/features/profit-loss-statement/profit-loss-statement.module').then(m => m.ProfitLossStatementsModule)
      },
      {
        path: 'monthly-invoice',
        canLoad: [CanLoadAdminSection],
        loadChildren: () => import('@teem/features/monthly-invoice/monthly-invoice.module').then(m => m.MonthlyInvoiceModule)
      },
      {
        path: 'reports',
        canLoad: [CanLoadAllowedModule, CanLoadAdminSection],
        loadChildren: () => import('@teem/features/reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'branches',
        canLoad: [CanLoadAllowedModule, CanLoadUserSection], // CanLoadAdminSection
        loadChildren: () => import('@teem/web-market/store-branches/branches.module').then(m => m.BranchesModule)
      },
      {
        path: 'zatca',
        loadChildren: () => import('@teem/features/zatca-phase-two/zatca-phase-two.module').then(m => m.ZatcaPhaseTwoModule)
      },
    ]
  },
  {
    path: '**',
    redirectTo: defaultRoute,
    pathMatch: 'full',
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [CanLoadAllowedModule, CanLoadAuthSection, CanLoadBasicSection, CanLoadProSection, CanLoadProductSection, CanLoadServiceSection, CanLoadBusinessSection, CanLoadSuperAdminSection, CanLoadAdminSection, CanLoadUserSection]
})
export class AppRoutingModule { }
